import { GetLeadVariantParams } from './types'

import { PlaybackStatus, Status } from 'modules/transmission/types'
import { LeadVariant } from 'modules/lead/types'

const FINISHED_STATUS = [Status.COMPLETED, Status.CLOSING]

export const getLeadVariant = ({
  isInWindowTime,
  isParticipant,
  maxParticipants,
  enableVodPlayback,
  status,
  isHotmartProvider,
  playbackStatus
}: GetLeadVariantParams) => {
  const isDownloadAvailable = playbackStatus === PlaybackStatus.DOWNLOAD_AVAILABLE
  const isCompleted = FINISHED_STATUS.includes(status)
  const hasRestrictions = maxParticipants > 0

  if (!hasRestrictions) {
    return null
  }

  if (isCompleted && (!isHotmartProvider || (isHotmartProvider && isDownloadAvailable))) {
    return null
  }

  if (!isInWindowTime) {
    return LeadVariant.SUCCESSFUL_SUBSCRIPTION
  }

  if (isParticipant) {
    return null
  }

  return enableVodPlayback ? LeadVariant.LIVE_FULL_WITH_PLAYBACK : LeadVariant.LIVE_FULL
}
